import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const userSlice = (state: RootState) => state?.user;

export const selectAuth = createSelector([userSlice], (auth) => auth.isAuth);
export const selectUser = createSelector([userSlice], (user) => {
  return user.user;
});
